import { ProviderOperationsConsole } from "features/providerOperations/ProviderOperationsConsole";
import { hasProviderOperationsAccess } from "features/providerOperations/hasProviderOperationsAccess";
import { isProviderOperationsEnabled } from "features/providerOperations/isProviderOperationsEnabled";
import "features/providerOperations/providerOperations.css";
import { useUserData } from "features/userData/context";
import { _ } from "i18n";
import type { Keys } from "i18n/locales/types";
import ForbiddenPage from "./errorPages/ForbiddenPage";
import NotFoundPage from "./errorPages/NotFoundPage";

export function ProviderOperationsPage() {
	const userData = useUserData();

	if (isProviderOperationsEnabled() === false) {
		return <NotFoundPage />;
	}

	if (hasProviderOperationsAccess(userData) === false) {
		return <ForbiddenPage />;
	}

	return (
		<div className="provider-operations-page">
			<h1>{_("providerOperations.page.title" as keyof Keys)}</h1>
			<p className="provider-operations-page__intro">{_("providerOperations.page.intro" as keyof Keys)}</p>
			<ProviderOperationsConsole />
		</div>
	);
}
